const WORK_STYLE_LABELS = {
    remote: 'Remote',
    hybrid: 'Hybrid',
    onsite: 'Onsite',
}

const getWorkStyleLabel = (value) => {
    if (!value) return null
    return WORK_STYLE_LABELS[value.toLowerCase()] || null
}

export default getWorkStyleLabel
